/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, ButtonBase, Drawer, Grid, IconButton, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {Close, CreditCard, Menu} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {REDES, SECCIONES} from "../../Constantes";
import {irUrl} from "../../Utilidades/irUrl";
import hoja from "../../Recursos/hoja.svg";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";


const BarraCell = ({esRoja}) => {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [adicionales, setAdicionales] = useState([])
    const ref = useRef()

    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'adicionales', wheres: w}).then((dox) => {
            setAdicionales(dox.data)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(180deg, #000 7.23%, rgba(0, 0, 0, 0.00) 100%)',
                backgroundColor: esRoja ? theme.palette.primary.main : '#00000000',
                mb: -16,
                px: 3,
                py: 3
            }}
        >

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img src={logo} width={200} height={'auto'} onClick={() => navigate('/Home')}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                <IconButton
                    onClick={() => setOpen(true)}
                    sx={{backgroundColor: esRoja ? '#00000000' : theme.palette.primary.main}}
                ><Menu sx={{fill: '#fff'}}/></IconButton>
            </Grid>

            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    navigate('/Home')
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    transition: 'all .1s ease-in-out',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    borderBottom: 1,
                                    borderColor: '#ffffff00',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#fff'
                                    }
                                }}
                            >
                                Home
                            </Typography>
                        </ButtonBase>
                    </Grid>

                    <Grid container size={{xs: 12, ms: 12, md: 12}}>
                        {SECCIONES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'center', marginTop: 2}}>
                                    <ButtonBase
                                        onClick={() => {
                                            setOpen(false)
                                            setTimeout(() => {
                                                navigate('/' + item)
                                            }, 500)
                                        }}

                                    >
                                        <Typography
                                            sx={{
                                                color: '#fff',
                                                fontSize: 20,
                                                fontWeight: 600,
                                                textAlign: 'center'
                                            }}>{item}</Typography>
                                    </ButtonBase>
                                </Grid>
                            )
                        })}

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        navigate('/Sostenibilidad')
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        transition: 'all .1s ease-in-out',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        borderBottom: 1,
                                        borderColor: '#ffffff00',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            borderColor: '#fff'
                                        }
                                    }}
                                >
                                    <span><img src={hoja} width={20} height={'auto'}
                                               style={{marginBottom: -4, marginTop: 2}}/></span> Sostenibilidad
                                </Typography>
                            </ButtonBase>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                            <Button
                                disabled
                                color={'secondary'}
                                onClick={() => {
                                    navigate('/Pagos')
                                    setOpen(false)
                                } }
                                startIcon={<CreditCard/>}>Pagos</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                            <Typography
                                sx={{
                                    color: '#fff',
                                    transition: 'all .1s ease-in-out',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    borderBottom: 1,
                                    borderColor: '#ffffff00',
                                }}
                            >
                                Mas
                            </Typography>
                        </Grid>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 1}}
                        >

                            {adicionales.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 6}}
                                          sx={{justifyContent: 'center', mt: 1}}>
                                        <Typography
                                            onClick={() => {
                                                setOpen(false)
                                                navigate('/Adicionales/' + it.id)
                                            }
                                            }
                                            sx={{
                                                transition: 'all .1s ease-in-out',
                                                fontSize: 16,
                                                borderBottom: 1,
                                                borderColor: '#ffffff00',
                                                color: '#fff',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    borderColor: '#ffffff',
                                                },
                                                lineHeight: 1.2,
                                                textAlign: 'center'

                                            }}
                                        >{it.nombre}</Typography>
                                    </Grid>
                                )
                            })}

                        </Grid>


                    </Grid>


                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 10}}>
                        <img src={logo} width={190} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 2}}>
                        {REDES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <item.icono sx={{fill: '#fff', height: 34, width: 34}}/>
                                    </IconButton>
                                </Grid>
                            )
                        })}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell